import React from "react";

function NoActions() {
    return (
        <div className="box-description null-body-detected-breach">
            <div className="row row-container">
                <div className="col-sm-3"></div>
                <div className="col-xs-12 col-sm-6 text-align-center col-main">
                    <div className="icon-main">
                        <em className="las la-check-circle complete-icon"></em>
                    </div>
                    <div>
                        <div className="title-main">You do not have any open actions.</div>
                        <div className="description">
                            BreachIQ is continuously monitoring your data. We will notify you if we detect your data has been exposed in a breach, and provide you
                            with custom actions here.
                        </div>
                    </div>
                </div>
                <div className="col-sm-3"></div>
            </div>
        </div>
    );
}

export default NoActions;
